import { z } from 'zod';

/** Generic non-empty string used widely. */
const nonEmptyName = z.string().min(1).max(200);

export const clientInputSchema = z.object({
  code: z.string().min(1).max(20).regex(/^[A-Z0-9_-]+$/, 'Client code: A-Z, 0-9, _ -'),
  name: nonEmptyName,
  taxId: z.string().max(20).optional(),
  active: z.boolean().default(true),
});
export type ClientInput = z.infer<typeof clientInputSchema>;

export const engagementInputSchema = z.object({
  clientId: z.string().uuid(),
  code: z.string().min(1).max(50),
  name: nonEmptyName,
  fiscalYear: z.number().int().min(2000).max(2100),
  active: z.boolean().default(true),
});
export type EngagementInput = z.infer<typeof engagementInputSchema>;

export const activityInputSchema = z.object({
  code: z.string().min(1).max(20),
  name: nonEmptyName,
  /** If true, can be selected by Staff/Senior; otherwise restricted. */
  chargeable: z.boolean().default(true),
  active: z.boolean().default(true),
});
export type ActivityInput = z.infer<typeof activityInputSchema>;

export const locationInputSchema = z.object({
  code: z.string().min(1).max(20),
  name: nonEmptyName,
  /** Optional geofence center (used only if we add geofence mode later). */
  lat: z.number().min(-90).max(90).optional(),
  lng: z.number().min(-180).max(180).optional(),
  /** Geofence radius in meters (used only if we add geofence mode later). */
  radiusM: z.number().int().min(10).max(10000).optional(),
  active: z.boolean().default(true),
});
export type LocationInput = z.infer<typeof locationInputSchema>;

export const employeeInputSchema = z.object({
  code: z.string().min(1).max(20),
  fullName: nonEmptyName,
  email: z.string().email().optional(),
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  active: z.boolean().default(true),
});
export type EmployeeInput = z.infer<typeof employeeInputSchema>;
